const NotValidUser = (props) => {
  return (
    <div className="error-fallback">
      <div className="msg">Seems like you don't have access at this moment. Please contact LEAD 4D support team.</div>
    </div>
  );
};

export default NotValidUser;
